module.exports = "./static/img_portrait.5bd89961.png";